globalThis.ListDialogue = class ListDialogue extends Dialogue {
  constructor(options) {
    super({
      title: "Load Save",
      body: "",
      ...options,
    });
    this.options = options.options || [];
    this.selected = options.selected;
    this.div.classList.add("list-dialogue");
    this.buttons = {};
    for (const key of this.options) {
      const button = document.createElement("button");
      button.innerText = key;
      button.addEventListener("click", () => this.select(key), this.abort);
      this.body.append((this.buttons[key] = button));
    }
    this.select(this.selected);
  }

  select(key) {
    if (!this.options.includes(key)) return;
    this.selected = key;
    for (const [savekey, button] of Object.entries(this.buttons))
      if (savekey === key) button.classList.add("active");
      else button.classList.remove("active");
  }
};
